const EXTRA_SPACE = 70;
const getExtraSpace = ({
  openedSheets,
  uuid,
  side,
  zIndex
}) => {
  var _sameSideOpenedSheets, _sameSideOpenedSheets2, _sameSideOpenedSheets3, _sameSideOpenedSheets4;
  const sameSideOpenedSheets = openedSheets.filter(openedSheet => openedSheet.side === side && parseInt(openedSheet.zIndex, 10) >= parseInt(zIndex, 10));
  const currentSheetIndex = sameSideOpenedSheets.findIndex(({
    id
  }) => id === uuid);
  // A Sheet does not need the extra spacing if
  // - its information is not in the context
  // - it is the first element in the array
  if (currentSheetIndex <= 0) {
    return '0px';
  }
  return `${Math.max(EXTRA_SPACE + ((_sameSideOpenedSheets = (_sameSideOpenedSheets2 = sameSideOpenedSheets[0]) === null || _sameSideOpenedSheets2 === void 0 ? void 0 : _sameSideOpenedSheets2.size) !== null && _sameSideOpenedSheets !== void 0 ? _sameSideOpenedSheets : 0) - ((_sameSideOpenedSheets3 = (_sameSideOpenedSheets4 = sameSideOpenedSheets[currentSheetIndex]) === null || _sameSideOpenedSheets4 === void 0 ? void 0 : _sameSideOpenedSheets4.size) !== null && _sameSideOpenedSheets3 !== void 0 ? _sameSideOpenedSheets3 : 0), 0)}px`;
};

export { getExtraSpace as g };
//# sourceMappingURL=getExtraSpace-DIh3XujE.js.map
